/**
 * Energy
 */
export const ENERGY_BASE_ROUTE = '/energy';
export const ENERGY_OVERVIEW_ROUTE = '/energy/overview';
export const ENERGY_HEALTH_ROUTE = '/energy/health';
export const ENERGY_WARRANTY_TRACKER_ROUTE = '/warranty-tracker';
export const ENERGY_PERFORMANCE_MANAGER_ROUTE = '/performance-manager';
export const ENERGY_ASSET_DASHBOARD_ROUTE = '/energy/overview';
export const ENERGY_SAFETY_ROUTE = '/safety';
export const ENERGY_REPORTS_V2_ROUTE = '/reports';
export const ENERGY_PENALTY_RISK_ROUTE = '/penalty-risk';
export const ENERGY_STORAGE_HIERARCHY_ROUTE = 'storage-hierarchy';
export const ENERGY_ALERTS_ROUTE = '/alerts';
export const ENERGY_BMS_ALERTS_ROUTE = '/bms-alerts';
export const ENERGY_EVENTS_ROUTE = '/events';
export const ENERGY_STORAGE_OVERVIEW_ROUTE = '/storage-overview';

/**
 * Mobility
 */
export const MOBILITY_BASE_ROUTE = '/mobility';
export const MOBILITY_FLEETS_ROUTE = '/mobility/groups';
export const MOBILITY_RULES_ROUTE = '/mobility/rules';
export const MOBILITY_CONFIGURATION_ROUTE = '/mobility/config';
// @deprecated since 09.03.24
export const MOBILITY_DEPRECATED_BASE_ROUTE = '/fleet-analytics';

/**
 * Model Library
 */
export const MODEL_LIBRARY_BASE_ROUTE = '/model-library/library';

/**
 * Shared
 */
export const DATA_EXPLORER_ROUTE = '/data-explorer';
export const REPORTING_ROUTE = '/reporting/library';
export const PROFESSIONAL_SERVICES_ROUTE = '/professional-services';
export const ANALYTICS_UPSELL_ROUTE = '/analytics';
export const ACCOUNT_SETTINGS_ROUTE = '/settings';
export const PRIVACY_POLICY_ROUTE = '/privacy-policy';
export const STORAGE_CONFIGURATION_ROUTE = '/storage-configuration';
